import React from 'react';

import Button, { ButtonProps } from '@material-ui/core/Button';

const BlueFullWidthButton = (buttonProps: ButtonProps) => {
    const { color, variant, style, ...otherProps } = buttonProps;

    const colorStyle = otherProps.disabled ? {} : {
        color: '#ffffff',
        backgroundColor: '#194560'
    };

    const additionalStyle = {
        width: '100%',
        borderRadius: 0
    };

    const finalStyle = { ...colorStyle, ...additionalStyle, ...style };

    return (
        <Button variant='contained' color={color} style={finalStyle} {...otherProps} />
    );
};

export default BlueFullWidthButton;
